<script>
export default {
  name: "Card",
  props: {
    item: Object,
  },
};
</script>

<template>
  <div class="card-container">
    <div class="card-body">
      <p>
        {{ item.text }}
      </p>
    </div>
  </div>
</template>

<style scoped>
.card-container {
  background: #fff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.15);
  width: 100%;
  border-radius: 3px;
  cursor: pointer;
  margin-bottom: 1rem;
}
.card-body {
  padding: 1rem;
}
p {
  font-size: 1rem;
  margin-bottom: 0;
}
</style>